import React from 'react';

import {
  HeadlineSkeleton,
  ImageSkeleton,
  TextSkeleton,
} from '@xingternal/malt-skeleton';
import { testable } from '@xingternal/malt-util';
import { QA_MALT } from '@xingternal/malt-constants';

import styles from './LoadingSkeleton.css';

const TestableDiv = testable(QA_MALT, 'div');

const TextLoadingSkeleton = () => (
  <TestableDiv testId={'login-loading-skeleton'}>
    <ImageSkeleton className={styles.image} width={96} height={96} />
    <HeadlineSkeleton size={'large'} />
    <TextSkeleton lineCount={6} />
  </TestableDiv>
);

export default TextLoadingSkeleton;
